import React from 'react';
import Select from '../../../components/ui/Select';

function LlmProfileSelects({
  llmModelLines,
  llmEfforts,
  llmModelLineId,
  setLlmModelLineId,
  llmEffortId,
  setLlmEffortId,
  isLoading,
  catalogError,
}) {
  const modelLineOptions = [
    { value: '', label: isLoading ? 'Carregando modelos...' : 'Selecione o modelo' },
    ...(llmModelLines || []).map((line) => ({
      value: line.id,
      label: line.label,
    })),
  ];

  const effortOptions = [
    { value: '', label: isLoading ? 'Carregando...' : 'Selecione o esforço' },
    ...(llmEfforts || []).map((effort) => ({
      value: effort.id,
      label: effort.label,
    })),
  ];

  return (
    <div className="space-y-4">
      <Select
        id="llm_model_line"
        label="Modelo"
        value={llmModelLineId}
        onChange={(e) => setLlmModelLineId(e.target.value)}
        options={modelLineOptions}
        disabled={isLoading || !llmModelLines.length}
        hint={
          !isLoading && !llmModelLines.length
            ? 'Nenhum modelo disponível. Um administrador precisa ativar famílias e configurar API keys em Catálogo LLM.'
            : undefined
        }
      />
      <Select
        id="llm_effort"
        label="Esforço"
        value={llmEffortId}
        onChange={(e) => setLlmEffortId(e.target.value)}
        options={effortOptions}
        disabled={isLoading || !llmModelLineId || !llmEfforts.length}
      />
      {catalogError && (
        <p className="text-sm text-red-600">{catalogError}</p>
      )}
    </div>
  );
}

export default LlmProfileSelects;
